var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"alert-info border-none pl-2 pt-1 pb-1",attrs:{"show":""}},[_c('div',{staticClass:"content-alert-info"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/icons/information-line.svg")}})]),_c('b',[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }